<template>
  <div>
    <div class="detail-info">
      <span class="info-title">类型：</span>
      <four-level
        :is-smart="true"
        :level="form.illness_level"
        @setNewLevel="setNewLevel"
      />
    </div>
    <div class="detail-info description-detail">
      <span class="info-title description">任务内容：</span>
      <el-input
        v-model="form.details"
        class="description"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>

  </div>
</template>

<script>
import FourLevel from "@components/common/FourLevel";
import { mapState } from "vuex";

export default {
  name: "SituationEdit",
  components: {
    FourLevel,
  },
  data() {
    return {
      form: {
        illness_level: "",
        details: "", // 详细描述
      },

    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
  },
  watch: {
    patient: {
      handler(val) {
        const { nobody_medicalstatus } = val;
        if (nobody_medicalstatus.length) {
          const { type, content } = nobody_medicalstatus[0];
          this.form = {
            illness_level: type, details: content,
          };
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 设置登记
     * */
    setNewLevel(val) {
      this.form.illness_level = val;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  width: 80px;
  height: 32px;
  border: 1px solid #999999;
  border-radius: 10px;
}

.info-key.unit {
  margin-left: 13px;
}

.el-input {
  width: auto;
  margin-left: 24px;
}

.injury-input {
  width: 399px;
  border-width: 1px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-color: #0c618b;
  color: #333;
  background: #fff;
  outline: none;
  font-size: 18px;
}

.diagnosed ::v-deep {
  margin-left: 0;

  .el-input__inner {
    width: 300px;
  }
}

.el-textarea.description {
  width: 640px;
  border-radius: 10px;
}

.description-detail {
  height: auto;
  margin-top: 12px;
}

.info-title.description {
  vertical-align: top;
  line-height: initial;
}

.detail-info {
  > div {
    display: inline-block;
  }
}
</style>
